import { render } from "./DocumentsArcelik.vue?vue&type=template&id=36407a23&scoped=true"
import script from "./DocumentsArcelik.vue?vue&type=script&lang=js"
export * from "./DocumentsArcelik.vue?vue&type=script&lang=js"

import "./DocumentsArcelik.vue?vue&type=style&index=0&id=36407a23&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36407a23"]])

export default __exports__